import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "worker_busy_modal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "This worker is booked in another shift", -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "w-40px me-3" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "fs-4 fw-bold" }
const _hoisted_11 = { class: "fs-5 fw-bolder" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Book Anyway ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_CircleInfoIcon = _resolveComponent("CircleInfoIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.payload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", {
                class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false))),
                "aria-label": "Close"
              }, [
                _createVNode(_component_XIcon)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CircleInfoIcon)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.payload.conflicting_shift.job_name), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.payload.conflicting_shift.label), 1)
                ]),
                _createElementVNode("a", {
                  target: "_blank",
                  href: 
                `/jobs/${_ctx.payload.conflicting_shift.job_id}/shifts?shift=${_ctx.payload.conflicting_shift.id}`
              ,
                  class: "btn text-dark bg-hover-opacity-75 ms-auto btn-secondary h-35px d-flex align-items-center justify-content-center"
                }, " View ", 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(false)))
              }, " Close "),
              (_ctx.payload.bookAnywayPayload)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    disabled: _ctx.loading,
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBookAnyway && _ctx.handleBookAnyway(...args)))
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                      : _createCommentVNode("", true),
                    _hoisted_16
                  ], 8, _hoisted_14))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}